export enum QuoteStatus {
  Quoting = 'Quoting',
  Selected = 'Selected',
  Rejected = 'Rejected',
  Processing = 'Processing',
}
